import { memo } from 'react';
export const ErrorField = memo((props) => {
    if (!props.error) {
        return null;
    }
    return <span className="text-sm mt-1 text-pink">{props.error}</span>;
});
